module.exports = __webpack_public_path__ + "static/media/45.a31a1870.png";